import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import OutsideClickHandler from 'react-outside-click-handler';
import {
  Container,
  HeaderContent,
  IntroUtp,
  IntroName,
  IntroIcon,
  ArrowDown,
  IntroText,
  NameUser,
  IntroText1,
  Logout,
  LogoutButton
} from './AdministratorHeaderStyled';
import Admin_logo from '../../../../../assets/icons/Admin_logo.svg';
import AdminIcon from '../../../../../assets/icons/AdminIcon.svg';
import IconClose from '../../../../../assets/icons/IconClose.svg';
import { Icon } from '@/presentation/components';

const AdministratorHeaderView = (props: any) => {
  const { handleLogOut } = props;
  const [viewButton, setViewButton] = useState(false);
  const openArrow = () => setViewButton((value) => !value);
  const { data } = useSelector((state: any) => state.auth);

  return (
    <Container data-testid="cmp-administrator-header-view">
      <HeaderContent>
        <div>
          <img src={Admin_logo} alt="Admin_logo" />
        </div>
        <IntroUtp>
          <IntroName>
            <IntroText>
              Hola, <NameUser>{data.userName}</NameUser>
            </IntroText>
            <IntroText1>Administrador</IntroText1>
          </IntroName>
          <IntroIcon>
            <img src={AdminIcon} alt="AdminIcon" />
            <div>
              <nav>
                <OutsideClickHandler
                  onOutsideClick={() => setViewButton(false)}
                >
                  <ArrowDown type="button" onClick={openArrow}>
                    <Icon name="chevron-down" size={28} color="#161d1f" />
                  </ArrowDown>
                  <Logout>
                    <li>
                      <LogoutButton
                        type="button"
                        onClick={handleLogOut}
                        className={
                          viewButton === false ? 'invisible' : 'visible'
                        }
                      >
                        <img
                          className="mr_icon"
                          src={IconClose}
                          alt="IconClose"
                        />
                        Cerrar sesión
                      </LogoutButton>
                    </li>
                  </Logout>
                </OutsideClickHandler>
              </nav>
            </div>
          </IntroIcon>
        </IntroUtp>
      </HeaderContent>
    </Container>
  );
};
export default AdministratorHeaderView;
